<template>
  <div class="electricity-statistics">
    <div class="main-title">
      <p>{{ $t('lang.Electricity Statistics') }}</p>
    </div>
    <div class="search-area">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
      >
        <el-form-item :label="$t('lang.Equipment ID/SN')">
          <el-input v-model="form.searchCondition" :placeholder="$t('lang.Please select the equipment name')"
                    clearable
                    maxlength="50"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Equipment Name')">
          <el-input v-model="form.deviceName" :placeholder="$t('lang.Please select the equipment name')"
                    clearable
                    maxlength="50"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Agent/Store')">
          <query-unit-tree @change="unitChange"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Equipment State')">
          <el-select v-model="form.serviceStatus" :disabled="!Boolean(form.unitNo)" placeholder="" clearable>
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Time')">
          <el-date-picker
            v-model="timeArr"
            type="datetimerange"
            range-separator="-"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            :start-placeholder="$t('lang.start time')"
            :end-placeholder="$t('lang.end time')">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('lang.Frequentness')">
          <el-select v-model="form.timeType" placeholder="">
            <el-option
              v-for="item in timeTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="search">{{ $t('lang.Inquire') }}</el-button>
        <el-button type="primary" @click="exportExcel">{{ $t('lang.Export') }}</el-button>
      </el-form>
      <div class="echarts-area">
        <div class="data-info-box">
          <div class="item">
            {{ $t('lang.Period Of Time') }}: {{dataInfo.time}}
          </div>
          <div class="item">
            {{ $t('lang.Frequentness') }}: {{dataInfo.frequentness}}
          </div>
          <div class="item">
            {{ $t('lang.Total Power Consumption') }}: {{dataInfo.amount}}
          </div>
        </div>
        <ltt-echarts
          refLabel="statistics"
          :option="statisticsOptions"
          :height="600"
        >
        </ltt-echarts>
      </div>
    </div>
  </div>
</template>

<script>
import queryUnitTree from '@/components/common/queryUnitTree';
import LttEcharts from '../../component/lttEcharts';
import {electricityStatistics,thailandExcelExport} from '@/api/deviceManagement'
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat)

export default {
  name: 'electricityStatistics',
  components: {
    LttEcharts,
    queryUnitTree
  },
  data() {
    return {
      // 显示数据的信息
      dataInfo: {
        time: '',
        frequentness: '',
        amount: ''
      },
      //echarts数据
      statisticsOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        dataZoom: [
          {
            show: true,
            start: 0,
            end: 8,
            bottom: 0,
          },
        ],
        color: ['#0075e7'],
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            data: [],
            type: 'bar'
          }
        ]
      },
      //状态列表
      statusList: [
        {
          label: this.$t('lang.Enable'),
          value: '1'
        },
        {
          label: this.$t('lang.Disable'),
          value: '0'
        }
      ],
      //可选时间列表
      timeTypeList: [
        {
          label: '15min',
          value: '0',
          minutes: 15
        },
        {
          label: '30min',
          value: '3',
          minutes: 30
        },
        {
          label: '1h',
          value: '1',
          minutes: 60
        }
      ],
      //时间
      timeArr: [],
      //提交数据
      form: {
        searchCondition: '',
        deviceName: '',
        unitNo: '',
        serviceStatus: '',
        timeType: '0',
      },
      flags: {
        isExportLoadingFlag: false
      }
    }
  },
  mounted() {
    let beginTime = dayjs(new Date()).format('YYYY-MM-DD 00:00:00')
    let endTime = dayjs(new Date()).format('YYYY-MM-DD 23:59:59')
    beginTime = Number(dayjs(beginTime).format('x'))
    endTime = Number(dayjs(endTime).format('x'))
    this.$set(this.timeArr, 0, beginTime)
    this.$set(this.timeArr, 1, endTime)
    this.search()
  },
  methods: {
    /**
     * 组织改变
     */
    unitChange(val) {
      if(val && val.length) {
        this.form.unitNo = val[val.length - 1]
        return
      }
      this.form.unitNo = ''
      this.form.serviceStatus = ''
    },
    /**
     * 查询
     */
    async search() {
      const params = {
        ...this.form,
      }
      if (this.timeArr && this.timeArr.length > 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x');
        params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x');
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      const res = await electricityStatistics(params)
      const list = res.mdata.electricity || {}
      const xAxis = []
      const xData = []
      //数据长度
      let xLength = 0
      //选择的频率
      const selectFrequency = this.timeTypeList.find((el) => {
        return params.timeType === el.value
      })
      for (const time in list) {
        const day = this.$changeTime.showTime(Number(time), 'HH:mm')  + ' - ' +
          this.$changeTime.showTime(dayjs(Number(time)).add(selectFrequency.minutes || 0, 'minute'), 'HH:mm')  +
          '\n' + this.$changeTime.showTime(Number(time), 'YYYY-MM-DD')
        const value = list[time]
        xAxis.push(day)
        xData.push(value)
        xLength++
      }
      this.statisticsOptions.xAxis.data = xAxis
      this.statisticsOptions.series[0].data = xData
      this.statisticsOptions.dataZoom[0].end = parseInt(8 / xLength * 100)
      //展示的信息
      const time = this.$changeTime.sendTime(this.timeArr[0], 'YYYY-MM-DD HH:mm', 0) + '-'
        + this.$changeTime.sendTime(this.timeArr[1], 'YYYY-MM-DD HH:mm', 0)
      let frequentness = this.timeTypeList.find((el) => {
        return el.value === params.timeType
      })
      if(frequentness) {
        frequentness = frequentness.label
      }
      this.dataInfo = {
        time,
        frequentness,
        amount: res.mdata.total
      }
    },
    /**
     * 导出
     */
    async exportExcel() {
      if(this.flags.isExportLoadingFlag) {
        return
      }
      const params = {
        ...this.form,
        exportType: 36
      }
      if (this.timeArr && this.timeArr.length > 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x');
        params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x');
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      try {
        this.flags.isExportLoadingFlag = true
        await thailandExcelExport(params)
        this.flags.isExportLoadingFlag = false
        this.$message({
          message: 'success',
          type: 'success'
        });
      } catch (e) {
        this.flags.isExportLoadingFlag = false
      }
    },
  }
}
</script>

<style scoped lang="scss">
.electricity-statistics {
  .search-area {
    position: absolute;
    left: 0;
    right: 0;
    top: 45px;
    width: 95%;
    margin: 14px;
  }
  .echarts-area {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    border: 1px solid #999999;
    .data-info-box {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 50px;
      font-size: 16px;
      border-bottom: 1px solid #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/electricityStatistics.vue